import React from 'react'
import { Field } from 'redux-form'
import { InputIdentifier, IdentifierLabel, IdentifierItemContainer } from './styles'

const renderIdentifierItem = props => {
  const inputValue = props.input.value
  return (
    <InputIdentifier
      {...props}
      onChange={e => {
        const arr = [...inputValue]
        if (!props.isSelected && !arr.find(item => item.placa === props.typeValue)) {
          arr.push({ placa: props.typeValue })
        } else {
          const pos = arr
            .map(arrItem => {
              return arrItem.placa
            })
            .indexOf(props.typeValue)
          arr.splice(pos, 1)
        }
        props.input.onChange(arr)
      }}
      value={props.input.value}
      type="checkbox"
      disabled={props.blocked}
    />
  )
}

function IdentifierItem(props) {
  return (
    <IdentifierItemContainer>
      <Field component={renderIdentifierItem} {...props} />
      <IdentifierLabel isSelected={props.isSelected} isBlockedEdit={props.blocked}>
        {`${props.label.substring(0, 3)}-${props.label.substring(3)}`}
      </IdentifierLabel>
    </IdentifierItemContainer>
  )
}

export default IdentifierItem



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/IdentifierItem.js